import type { LogLevel } from './types'

const isProduction = process.env.NODE_ENV === 'production'

export function formatLog(level: LogLevel, namespace: string, message: string, meta?: Record<string, unknown>): string {
  if (isProduction) {
    try {
      return JSON.stringify({
        level,
        ns: namespace,
        msg: message,
        ...meta,
        ts: new Date().toISOString()
      })
    } catch {
      return JSON.stringify({ level, ns: namespace, msg: message, ts: new Date().toISOString() })
    }
  }

  let metaStr = ''
  if (meta && Object.keys(meta).length > 0) {
    try {
      metaStr = ` ${JSON.stringify(meta)}`
    } catch {
      metaStr = ' [unserializable meta]'
    }
  }
  return `[${namespace}] ${level}: ${message}${metaStr}`
}
